import React from 'react';

export const Footer = () => {
  return (
    <footer 
      className="py-12"
      style={{ borderTop: '1px solid var(--color-rule)' }}
      data-testid="site-footer"
    >
      <div 
        className="section"
        style={{ maxWidth: 'var(--max-width)', margin: '0 auto' }}
      >
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p 
            style={{ 
              fontFamily: 'var(--font-mono)',
              fontSize: '10px',
              color: 'var(--color-muted)',
              letterSpacing: '0.1em',
              margin: 0
            }}
          >
            ImagineNation LLC
          </p>
          
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '24px'
          }}>
            <a 
              href="https://www.notmarcohansell.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ 
                fontFamily: 'var(--font-mono)',
                fontSize: '10px',
                color: 'var(--color-muted)',
                letterSpacing: '0.05em',
                textDecoration: 'none'
              }}
              data-testid="footer-website"
            >
              WEBSITE
            </a>
            <a 
              href="https://www.instagram.com/mhansell"
              target="_blank"
              rel="noopener noreferrer"
              style={{ 
                fontFamily: 'var(--font-mono)',
                fontSize: '10px',
                color: 'var(--color-muted)',
                letterSpacing: '0.05em',
                textDecoration: 'none'
              }}
              data-testid="footer-instagram"
            >
              INSTAGRAM
            </a>
            <a 
              href="https://www.linkedin.com/in/mhansell/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ 
                fontFamily: 'var(--font-mono)',
                fontSize: '10px',
                color: 'var(--color-muted)',
                letterSpacing: '0.05em',
                textDecoration: 'none'
              }}
              data-testid="footer-linkedin"
            >
              LINKEDIN
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
